import { create } from 'zustand'

type RewardGainActivityState = {
  /** `true` enquanto a fila de badges de ganho tem um lote em exibição. */
  active: boolean
  setActive: (active: boolean) => void
}

/**
 * Sinal compartilhado de "a fila de badges está ocupada".
 *
 * A fila vive em `useRewardGainQueue`, montado só pelo host; quem precisa
 * esperar ela esvaziar antes de abrir outra superfície (o nudge da lojinha)
 * não tem como ler o `batch` de lá. Este store é o ponto de encontro.
 */
export const useRewardGainActivityStore = create<RewardGainActivityState>(
  set => ({
    active: false,
    setActive: active => set({ active })
  })
)
